import L from "leaflet";
import { Marker } from "react-leaflet";
import { TuristVeg } from "../../../services/RuteplanAPI";
import turistvegIconResource from "../../../assets/NasjonalTuristveg.svg"
import { useRouteFeatureDialogStoreActions } from "../../../stores/RouteFeatureDialogStore";

const turistvegIcon = L.icon({
    iconUrl: turistvegIconResource,
    iconRetinaUrl: turistvegIconResource,
    iconAnchor: [14, 28],
    iconSize: [28, 28]
  });

export interface ITuristvegMarkersProps {
    turistveger: Array<TuristVeg>;
}

export default function TuristvegMarkers (props: ITuristvegMarkersProps) {
    const { setClickedRoadFeature, setRoadFeatureDialogIsOpen } = useRouteFeatureDialogStoreActions();

    const { turistveger } = props;

    return (
        <>
            {turistveger.map((turistveg: TuristVeg, index: number) => {
                return (
                    <Marker key={turistveg.navn + index} 
                    position={[turistveg.location!.y, turistveg.location!.x]} 
                    icon={turistvegIcon}
                    eventHandlers={{
                        click: () => {
                            setClickedRoadFeature(turistveg);
                            setRoadFeatureDialogIsOpen(true);
                        }
                    }}
                    />
                )
            })}
        </>
    )
}